export const MockShipmentData = [
  {
    loadId: '1000509244',
    loadPostingStatus: 'NEW',
    sourceSystem: 'MASTERMIND',
    isHazardous: false,
    isHighValue: false,
    isTemperatureControlled: false,
    totalDistance: 461.66,
    distanceUOM: 'mi',
    totalWeight: 34000,
    weightUOM: 'lb',
    numberOfStops: 2,
    transportMode: 'Dry Van',
    termsAndConditions: null,
    rate: {
      binRateIdentifier: '1_8CE04287A167B31D75818E98BB468D81',
      totalCharge: 996.92,
      lineHaulCharge: {
        charge: 770.71,
        unitCharge: 770.71,
        quantity: 1,
        rateQualifier: 'Flat Rate',
        chargeDescription: 'Line Haul',
      },
      fuelCharge: {
        charge: 226.21,
        unitCharge: 0.49,
        quantity: 461.66,
        rateQualifier: 'Per Mile',
        chargeDescription: 'Fuel Surcharge',
      },
      accessorials: [],
    },
    loadStop: [
      {
        locationName: 'DOUMAK INC',
        addressLine1: '1006 FAIRWAY DR',
        addressLine2: null,
        stopSequence: 1,
        stopType: 'P',
        city: 'BENSENVILLE',
        state: 'IL',
        postalCode: '60106-1317',
        country: 'USA',
        stopId: 'OTM_SM100998783_268922676',
        appointmentFrom: '2024-09-05T07:00-05:00',
        appointmentTo: '2024-09-05T10:00-05:00',
        timeZone: 'US/Central',
        deadHead: '21.724',
        appointmentState: 'A',
        specialServices: [
          {
            specialServiceDesc: 'Live Load',
          },
        ],
      },
      {
        locationName: 'DOLLAR GENERAL',
        addressLine1: '5719 N 16TH ST',
        addressLine2: null,
        stopSequence: 2,
        stopType: 'D',
        city: 'OMAHA',
        state: 'NE',
        postalCode: '68110-1161',
        country: 'USA',
        stopId: 'OTM_SM100998783_268922677',
        appointmentFrom: '2024-09-06T17:00-05:00',
        appointmentTo: '2024-09-06T20:00-05:00',
        timeZone: 'US/Central',
        deadHead: null,
        appointmentState: 'A',
        specialServices: [
          {
            specialServiceDesc: 'Drop Loaded Trailer',
          },
        ],
      },
    ],
    buyAllowed: true,
    managedEquipment: false,
    exclusiveLoad: false,
    specialServices: [],
  },
  {
    loadId: 'SL100240054',
    loadPostingStatus: 'NEW',
    sourceSystem: 'MERCURYGATE',
    isHazardous: false,
    isHighValue: false,
    isTemperatureControlled: false,
    totalDistance: 400,
    distanceUOM: 'mi',
    totalWeight: 31291,
    weightUOM: 'lb',
    numberOfStops: 2,
    transportMode: 'Dry Van',
    termsAndConditions: null,
    rate: {
      binRateIdentifier: '1071078727_C7ACF91A7A2568451EFDD65C880C1A95',
      totalCharge: 1069.26,
      lineHaulCharge: {
        charge: 877.26,
        unitCharge: 877.26,
        quantity: 1,
        rateQualifier: 'Flat Rate',
        chargeDescription: 'Line Haul',
      },
      fuelCharge: {
        charge: 192,
        unitCharge: 0.48,
        quantity: 400,
        rateQualifier: 'Per Mile',
        chargeDescription: 'Fuel Surcharge',
      },
      accessorials: [],
    },
    loadStop: [
      {
        locationName: null,
        addressLine1: null,
        addressLine2: null,
        stopSequence: 2,
        stopType: 'D',
        city: 'XENIA',
        state: 'OH',
        postalCode: '45385-4011',
        country: 'USA',
        stopId: 'SL100240054_D_2',
        appointmentFrom: '2024-09-08T07:00-04:00',
        appointmentTo: '2024-09-08T14:00-04:00',
        timeZone: 'US/Eastern',
        deadHead: null,
        appointmentState: 'A',
        specialServices: [
          {
            specialServiceDesc: 'Customer Live Unload',
          },
        ],
      },
      {
        locationName: null,
        addressLine1: null,
        addressLine2: null,
        stopSequence: 1,
        stopType: 'P',
        city: 'OAK CREEK',
        state: 'WI',
        postalCode: '53154-4306',
        country: 'USA',
        stopId: 'SL100240054_P_1',
        appointmentFrom: '2024-09-07T07:00-05:00',
        appointmentTo: '2024-09-07T14:00-05:00',
        timeZone: 'US/Central',
        deadHead: '79.163',
        appointmentState: 'A',
        specialServices: [
          {
            specialServiceDesc: 'Customer Live Load',
          },
        ],
      },
    ],
    buyAllowed: true,
    managedEquipment: false,
    exclusiveLoad: false,
    specialServices: [],
  },
];
